import { Button, DownloadSVG } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";

import { buttonIconCss } from "./DownloadSearchResultsButton.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

export const DownloadSearchResultsButton = () => {
  /** TODO: Remove when backend work is complete */
  const todoAlert = () => alert("Awaiting backend work...");

  const [hasAdminDirectoryDownloadFeature] = useGetUserExperimentSegment(
    "admin-directory-search-download",
  );

  const isInExperimentFeatureGroup = hasAdminDirectoryDownloadFeature === "on";

  if (!isInExperimentFeatureGroup) return null;

  return (
    <ButtonWithTrackEvent
      actionName={actionNames.download}
      actionPrefix={actionPrefixes.initiate}
      dataProps={{ "data-qa-selector": "directory-search-download-button" }}
      flavor={Button.flavors.tertiary}
      icon={{
        alignment: "left",
        SvgComponent: DownloadSVG,
      }}
      objectType={objectTypes.user}
      onClick={todoAlert}
      streamProperties={{
        description: `User initiated download of search results`,
      }}
      __cssFor={{
        Icon: {
          root: buttonIconCss,
        },
      }}
    >
      Download search results .csv
    </ButtonWithTrackEvent>
  );
};

export default DownloadSearchResultsButton;
